// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__LkaJ4","hero__content":"Hero_hero__content__vvEOt","hero__image":"Hero_hero__image__Kcu8B","links":"Hero_links__iabW5"};